/* ============================================================
 * divein-carousel-init.js  —— 轮播初始化兜底
 * 问题：主题只在 window.load 才遍历 .grid-slider / .js_carousel
 *       调 gridSlider() 初始化。图片多/网慢时偶发没 init，
 *       箭头整组缺失（表现："箭头偶尔直接没有"）。
 * 这里在多个时机补初始化尚未 init 的轮播。
 * 放法：Assets 新建本文件，在 Layout/theme.liquid 的
 *       </body> 前一行加：
 *       {{ 'divein-carousel-init.js' | asset_url | script_tag }}
 * ============================================================ */
(function () {
  function initPending() {
    var $ = window.jQuery;
    if (!window.jQuery || !$.fn || !$.fn.gridSlider) return;
    var nodes = document.querySelectorAll(
      '.grid-slider:not(.slick-initialized), .js_carousel:not(.slick-initialized)'
    );
    if (!nodes.length) return;
    nodes.forEach(function (el) {
      try { $(el).gridSlider(); } catch (e) { /* 单条失败忽略，下个时机再试 */ }
    });
  }

  function schedule() {
    [400, 1200, 2500, 4500].forEach(function (t) {
      setTimeout(initPending, t);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.addEventListener('load', function () {
    [300, 1500, 3500].forEach(function (t) { setTimeout(initPending, t); });
  });

  // 懒加载图片就位后也补一次（主题用魔改 lazysizes）
  document.addEventListener('lazyloaded', function () { setTimeout(initPending, 300); });
})();
